import { render, staticRenderFns } from "./SendImage.vue?vue&type=template&id=3f04c4a6&"
import script from "./SendImage.vue?vue&type=script&lang=js&"
export * from "./SendImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports